export default __webpack_public_path__ + "static/media/perks3.ef4bcc09.png";